// features/Vault/hooks/useVaultInfiniteMedia.ts
import { useMemo } from 'react'

import { useInfiniteQuery, useQueryClient } from 'react-query'

import { getAllVaultMedia } from 'services/endpoints/vault'

import {
  type MediaType,
} from '../vault.constants'


type Args = {
  vaultKey: string
  activeFilter: string
  shouldFetch: boolean
  activeCategory: any[]
  selectedCategoryId: number | null
  isGrouped: boolean
  showDuplicates: boolean
  unreleasedOnly: boolean
  postsSort: string
  postsAsc: string
  postsFilter: MediaType
  setMedia: (arr: any[]) => void
  setVaultMedia: (k: string, v: any) => void
  allTimeStats: boolean
/*   showPaidOnly: boolean
  setShowPaidOnly: (v: boolean) => void */
  priceOnly: boolean
}

export function useVaultInfiniteMedia({
  vaultKey,
  activeFilter,
  shouldFetch,
  activeCategory,
  selectedCategoryId,
  isGrouped,
  showDuplicates,
  unreleasedOnly,
  postsSort,
  postsAsc,
  postsFilter,
  setMedia,
  setVaultMedia,
  allTimeStats,
  priceOnly,
}: Args) {

  const queryKey = useMemo(() => ['vaultMedia', vaultKey] as const, [vaultKey])



const queryEnabled =
  shouldFetch &&
  activeCategory !== null &&
  typeof activeCategory?.[0]?.id !== 'undefined'
const query = useInfiniteQuery(
  queryKey,
  async ({ pageParam = 0 }) => {
    console.trace('VAULT QUERY', {
      vaultKey,
      pageParam,
      activeFilter,
      category: selectedCategoryId,
      time: Date.now(),
    })

    const queryArgs: any = {
      mapExistingPostId: false,
      show_duplicates: showDuplicates,
      grouped: isGrouped,
      all_time_stats: allTimeStats,
      price: priceOnly,
      unreleased_only: unreleasedOnly,
      filter: postsFilter,
    }

    if (isGrouped && selectedCategoryId !== null) {
      queryArgs.category = selectedCategoryId
    }

    if (postsSort) {
      queryArgs.sort = postsSort
      queryArgs.sortAsc = postsAsc || 'desc'
    }

    return await getAllVaultMedia(activeFilter, pageParam, queryArgs)
  },
{
    enabled: queryEnabled,

    refetchOnMount: true,
    refetchOnWindowFocus: true,
    refetchOnReconnect: true,

    staleTime: 5 * 60 * 1000,

    refetchInterval: queryEnabled
      ? 30 * 60 * 1000
      : false,

    refetchIntervalInBackground: false,

    getNextPageParam: (lastPage: any, pages: any[]) => {
      console.log('VAULT NEXT PAGE', {
        pages: pages.length,
        lastNextPage: lastPage?.nextPage,
      })

      return lastPage?.nextPage ?? undefined
    },

    onSuccess: (resp: any) => {
      console.log('VAULT SUCCESS', {
        pageCount: resp.pages.length,
        pageParams: resp.pageParams,
        nextPages: resp.pages.map((page: any) => page?.nextPage),
      })

      const flat = resp.pages.flatMap((page: any) => page.data)

      setVaultMedia(vaultKey, resp.pages[0])
      setMedia(flat)
    },
  }
)
  return { ...query, queryKey, queryEnabled }
}